import { CSSProperties, useMemo } from 'react'
import { MetaOverlayConfiguration } from '../../views/shared/conformed/common'

const gradientDirectionMap = {
	'to-r': 'to right',
	'to-l': 'to left',
	'to-t': 'to top',
	'to-b': 'to bottom',
	'to-tr': 'to top right',
	'to-tl': 'to top left',
	'to-br': 'to bottom right',
	'to-bl': 'to bottom left',
} as const

export function ImageOverlay({
	overlay,
}: {
	overlay: MetaOverlayConfiguration
}) {
	const style: CSSProperties = useMemo(() => {
		if (overlay.fillMode === 'none') {
			return {}
		}

		let styles: CSSProperties = {
			mixBlendMode: overlay.fillBlendMode,
		}

		if (overlay.fillMode === 'flat') {
			styles.backgroundColor = overlay.fillFlatColor
		}

		if (overlay.maskMode === 'flat') {
			styles.opacity = overlay.maskFlatOpacity
		}

		if (overlay.maskMode === 'gradient') {
			styles.maskImage = `linear-gradient(${
				gradientDirectionMap[overlay.maskGradientDirection]
			}, rgba(0,0,0,${overlay.maskGradientOpacity1}) ${
				overlay.maskGradientStop1 * 100
			}%, rgba(0,0,0,${overlay.maskGradientOpacity2}) ${overlay.maskGradientStop2 * 100}%)`
		}

		return styles
	}, [overlay])

	return <div className="absolute inset-0 transition-all" data-is="image-overlay" style={style} />
}
